var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoccerBall = function SvgSoccerBall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5 4 9l4 3 4-3-2-4H6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm-7 9c0-3.9 3.1-7 7-7 2.8 0 5.2 1.6 6.3 3.9L14 10l2.3 3.1c-.8 1.6-2.2 2.9-3.9 3.5L9 14l-2.6 2C4.3 14.8 3 12.5 3 10z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgSoccerBall;